// extracted by mini-css-extract-plugin
export default {"link":"Gift_link__+x69q","no_hover":"Gift_no_hover__XZ5EF"};